import { Provider } from 'react-redux'
import { NetworkProvider } from '~/networkProvider'
import { ServiceWorkerProvider } from '~/serviceWorkerProvider'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from '~/config/globalStyles'
import FilestackStyles from '~/config/filestackStyles'
import theme from '~/config/theme'
import { AuthProvider } from '~/components/AuthProvider'

import store from '~/store'
import { ApolloProvider } from '~/client'
import { ReactAriaRouterProvider } from '~/providers/ReactAriaRouterProvider'
import { ErrorBoundary } from '~/components/ErrorBoundary'
import { AppContainer } from '~/components/AppContainer'
import { AppAlert, NetworkBanners } from '~/components/Alerts'
import { ApplicationUpdatedModal } from '~/components/Modals/ApplicationUpdatedModal'
import { Outlet } from 'react-router-dom'

export const Providers = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ServiceWorkerProvider>
          <GlobalStyles />
          <FilestackStyles />
          <NetworkProvider>
            <AuthProvider>
              <ApolloProvider>
                <AppContainer>
                  <NetworkBanners />
                  <AppAlert />
                  <ReactAriaRouterProvider>
                    <ErrorBoundary>
                      <Outlet />
                    </ErrorBoundary>
                  </ReactAriaRouterProvider>
                  <ApplicationUpdatedModal />
                </AppContainer>
              </ApolloProvider>
            </AuthProvider>
          </NetworkProvider>
        </ServiceWorkerProvider>
      </ThemeProvider>
    </Provider>
  )
}
